module.exports = __webpack_public_path__ + "influicons.0b3835ec236c154ff921e4744b89c58c.woff";